export default __webpack_public_path__ + "static/media/instagram-1.72cb9de0.jpeg";